import { authHeader } from '../_helpers';
import { settings } from '../settings';

export const tourService = {
  logout,
  getAll,
  getSingleDetail,
  getAllAtOnce,
  getToday,
  getStats,
  getCompleteTour
};

function logout() {
  // remove user from local storage to log user out
  localStorage.removeItem('user');
}

function getAll(rows, page, sortby, descending) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };
  console.log(rows);
  const r =
    '?items_per_page=' +
    rows +
    '&page=' +
    page +
    '&orderby=' +
    sortby +
    '&desc=' +
    descending;

  return fetch(`${settings.apiUrl}/tours/` + r, requestOptions).then(
    handleResponse
  );
}

function getToday() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(`${settings.apiUrl}/tours/today`, requestOptions).then(
    handleResponse
  );
}

function getStats() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };
  console.log('getStats');
  return fetch(`${settings.apiUrl}/tours/stats`, requestOptions).then(
    handleResponse
  );
}

function getCompleteTour(loadno) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };
  console.log('getCompleteTour');
  return fetch(`${settings.apiUrl}/tours/loadno/complete/` + loadno, requestOptions).then(
    handleResponse
  );
}

function getAllAtOnce() {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };
  console.log('getAllAtOnce');
  return fetch(`${settings.apiUrl}/tours/all`, requestOptions).then(
    handleResponse
  );
}

function getSingleDetail(loadno) {
  const requestOptions = {
    method: 'GET',
    headers: authHeader()
  };

  return fetch(
    `${settings.apiUrl}/tours/loadno/` + loadno,
    requestOptions
  ).then(handleResponse);
}

function handleResponse(response) {
  return response.json().then(json => {
    const data = json;
    if (!response.ok) {
      if (response.status === 401) {
        logout();
        location.reload(true);
      }

      const error = (data && data.message) || response.statusText;
      return Promise.reject(error);
    }
    return Promise.resolve(data);
  });
}
